/**
 * PromotionBanner — "Promotion Detected" banner for SgpFlowScreen.
 * Extracted verbatim from SgpFlowScreen.jsx (god-file decomposition).
 * Renders only when `promotion` is truthy with a `.type` (parent guards with &&).
 */

import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';

export default function PromotionBanner({ promotion, onDismiss }) {
  if (!promotion || !promotion.type) return null;
  return (
    <View style={{ alignSelf: 'stretch', marginBottom: 12, padding: 12, backgroundColor: 'rgba(139, 92, 246, 0.15)', borderRadius: 8, borderLeftWidth: 3, borderLeftColor: '#8b5cf6', flexDirection: 'row', alignItems: 'flex-start', gap: 12 }}>
      <View style={{ flex: 1 }}>
        <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8, marginBottom: 4 }}>
          <Text style={{ fontSize: 20 }}>🎁</Text>
          <Text style={{ color: '#c4b5fd', fontSize: 14, fontWeight: '700', textTransform: 'uppercase' }}>Promotion Detected</Text>
            </View>
        <Text style={{ color: 'rgba(255,255,255,0.9)', fontSize: 15, fontWeight: '600', marginBottom: 2 }}>
          {promotion.value} {promotion.type.replace(/_/g, ' ').toUpperCase()}
        </Text>
        {promotion.sportsbook && (
          <Text style={{ color: 'rgba(255,255,255,0.7)', fontSize: 13 }}>
            📱 {promotion.sportsbook}
          </Text>
        )}
        {promotion.conditions && (
          <Text style={{ color: 'rgba(255,255,255,0.6)', fontSize: 12, marginTop: 4, fontStyle: 'italic' }}>
            {promotion.conditions}
          </Text>
        )}
        {promotion.expiry && (
          <Text style={{ color: '#fbbf24', fontSize: 12, marginTop: 4 }}>
            ⏰ Expires: {promotion.expiry}
          </Text>
        )}
      </View>
      <TouchableOpacity onPress={onDismiss} style={{ padding: 4 }}>
        <Text style={{ color: 'rgba(255,255,255,0.5)', fontSize: 18 }}>✕</Text>
      </TouchableOpacity>
    </View>
  );
}
